import { ICredentialService } from "../../service/credential/CredentialService";

export default class CheckLoginStatusInteractor {
  private credentialService: ICredentialService;

  constructor({
    credentialService
  }: {
    credentialService: ICredentialService;
  }) {
    this.credentialService = credentialService;
  }

  async execute() {
    return this.credentialService.getLoggedIn();
  }
}
